var map = {
	"./backwelltech.svg": 75094,
	"./bepower.png": 64854,
	"./bookingmyhotel.avif": 45095,
	"./gallucci-editore.png": 3074,
	"./hellobarrio.svg": 32972,
	"./ictc.png": 38682,
	"./limo.png": 26907,
	"./mechit.png": 31061,
	"./memorabid.svg": 66645,
	"./sailsquare.svg": 22047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36380;